const brandColor = {
  primary: 'linear-gradient(90deg,rgba(255, 194, 14, 1) 0%, rgba(215, 25, 32, 1) 100%',
  yellow: '#FFC20E',
  red: '#D71920',
}

const color = {
  gray: '#F2F3F4',
  gray600: '#1F2024',
  gray500: '#344054',
  gray400: '#2F3036',
  gray300: '#494A50',
  gray200: '#71727A',
  gray100: '#8F9098',
  light: '#8A95A8',
  light500: '#C5C6CC',
  light400: '#D4D6DD',
  light300: '#E8E9F1',
  light200: '#F8F9FE',
  light100: '#FFFFFF',
  greenLight: '#22C55E',
  success: '#07A721',
  successDark: '#3AC0A0',
  successSurface: '#F2F8F2',
  error: '#ED3241',
}

export default {
  brandColor,
  color
}